import { requestJson } from "./http/httpClient";
import { readNullableString, readObject, readString } from "./http/jsonDecoding";

/** Which deploy the server runs (F160; `server/src/dmw/api/server_build.py`). */
export interface ServerBuild {
  /** The deployed commit; `null` for a server run from a checkout. */
  readonly commit: string | null;
  /** ISO 8601: when this server started, which is when the deploy went live. */
  readonly startedAt: string;
}

export function readServerBuild(signal?: AbortSignal): Promise<ServerBuild> {
  return requestJson({
    method: "GET",
    path: "/server/build",
    signal,
    decodeResponse: (body) => {
      const build = readObject(body, "server build");
      return { commit: readNullableString(build, "commit"), startedAt: readString(build, "started_at") };
    },
  });
}
